import React from 'react';
import { Box, Stack } from '@mui/material';
import EmployeeSettings from '../components/settings/EmployeeSettings';
import ClinicSettings from '../components/settings/ClinicSettings';
import KeywordsSettings from '../components/settings/KeywordsSettings';

export default function Settings() {
  return (
    <Box sx={{ p: 3, bgcolor: 'white' }}>
      <Stack spacing={3}>
        <EmployeeSettings />
        <ClinicSettings />
        <KeywordsSettings />
      </Stack>
    </Box>
  );
}